import Hero from './Hero'
import Intro from './Intro'
import Content from './Content'
import Gallery from './Gallery'
import Awards from './Awards'
import Quote from './Quote'
import Related from './Related'

import { Cta } from 'shared-components'

import s from './SingleProject.module.sass'

function SingleProject({ project, relatedProjects, siteSettings, icon, site }: any) {
    return (
        <article className={s.SingleProject}>
            <Hero project={project} />
            <Intro project={project} icon={icon} />
            <Content project={project} />
            <Gallery project={project} />
            <Awards project={project} />
            <Quote project={project} />
            <Related relatedProjects={relatedProjects} />
            <Cta _type="cta" site={site} useFieldsFromSettings siteSettings={siteSettings} />
        </article>
    )
}

export default SingleProject
